module.exports = __webpack_public_path__ + "static/media/metabolomic.5e50ef6b.jpeg";